/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".front-document-scan[_ngcontent-%COMP%]{padding-top:8px}.front-document-scan[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-size:24px;line-height:32px;font-weight:300;letter-spacing:0;color:#231d19}.front-document-scan[_ngcontent-%COMP%]   .animation[_ngcontent-%COMP%]{margin-top:65px;margin-bottom:24px}"];
export { styles as styles };
